import AdminHeader from "components/Headers/AdminHeader";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Input,
  FormGroup,
  Label,
  Badge,
} from "reactstrap";
import React, { useState } from "react";
import Select from "react-select";
import {
  REGEX,
  SELECT_CUSTOM_STYLES,
  MAX_FILE_SIZE,
} from "constants/CommonConstants";
import Avatar from "components/CommonComponents/Avatar";

const initialFields = {
  fullName: {
    value: "",
    error: "",
  },

  email: {
    value: "",
    error: "",
  },

  mobileNo: {
    value: "",
    error: "",
  },

  dateOfBirth: {
    value: "",
    error: "",
  },

  gender: {
    value: "",
    error: "",
  },

  address: {
    value: "",
    error: "",
  },

  profilePhoto: {
    value: null, // File object OR existing image URL
    preview: "", // for image preview
    error: "",
  },

  // Read-only fields
  role: {
    value: "",
  },

  accountStatus: {
    value: "",
  },

  lastLogin: {
    value: "",
  },

  createdOn: {
    value: "",
  },
};

const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

const profileData = {
  fullName: "Rakesh Kumar",
  email: "admin@raychem.com",
  mobileNo: "9876543210",
  dateOfBirth: "1990-10-12",
  gender: "Male",
  address: "Mumbai 400001, Maharashtra, India",
};

function AdminProfile() {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState(initialFields);

  const handleEdit = () => {
    setFormData({
      fullName: { value: profileData.fullName, error: "" },
      email: { value: profileData.email, error: "" },
      mobileNo: { value: profileData.mobileNo, error: "" },
      dateOfBirth: { value: profileData.dateOfBirth, error: "" },
      gender: { value: profileData.gender, error: "" },
      address: { value: profileData.address, error: "" },
      profilePhoto: { value: null, preview: "", error: "" },
      role: { value: "Administrator" },
      accountStatus: { value: "Active" },
      lastLogin: { value: "3hr ago" },
      createdOn: { value: "12/12/25" },
    });

    setIsEditing(true);
  };

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: {
        value: value,
        error: "",
      },
    }));
  };

  const getValidationError = (name, value) => {
    switch (name) {
      case "fullName":
        if (!value) return "Full name is required";
        else if (value.length < 3 || value.length > 100)
          return "Full name must be 3–100 characters";
        else if (!REGEX.ONLY_ALPHABETS_REGEX.test(value))
          return "Only alphabets and spaces allowed";
        return "";

      case "email":
        if (!value) return "Email is required";
        else if (!REGEX.EMAIL_REGEX.test(value)) return "Invalid email format";
        return "";

      case "mobileNo":
        if (!value) return "Mobile number is required";
        else if (!REGEX.PHONE_NO_REGEX.test(value))
          return "Enter valid mobile number";
        return "";

      case "address":
        if (value.length > 250)
          return "Address should less than 250 characters";
        return "";

      default:
        return "";
    }
  };

  const handleBlur = (name, value) => {
    const error = getValidationError(name, value);
    setFormData((prev) => ({
      ...prev,
      [name]: { value, error },
    }));
  };

  const handleSave = () => {
    // if (!validateForm()) return;
    setIsEditing(false);
  };

  const handleOnCancel = () => {
    setFormData(initialFields);
    setIsEditing(false);
  };

  return (
    <>
      <AdminHeader name="My Profile" />

      <Container className="mt--6" fluid>
        <Row>
          <Col xl="12">
            {/* Profile Summary */}
            <Card className="shadow mb-4">
              <CardBody className="position-relative">
                <Row className="align-items-center">
                  {/* Profile Image */}
                  <Col md="2" className="text-center">
                    <FormGroup className="profile-photo-container position-relative text-center">
                      {formData.profilePhoto?.value ? (
                        <img
                          src={formData.profilePhoto.value.preview}
                          alt="profilePhoto"
                          className="profile-photo-preview"
                        />
                      ) : (
                        <Avatar
                          name={formData.fullName?.value || "Rakesh Sharma"}
                        />
                      )}

                      {isEditing && (
                        <>
                          <small className="text-muted d-block mt-2">
                            Accepted formats: PNG, JPG. Maximum file size: 2 MB.
                          </small>
                          <span
                            className="profile-img-edit cursor-pointer"
                            onClick={() =>
                              document
                                .getElementById("profilePhotoInput")
                                .click()
                            }
                          >
                            <i className="fa fa-camera" />
                          </span>

                          <Input
                            type="file"
                            id="profilePhotoInput"
                            accept="image/png,image/jpeg"
                            className="d-none"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file && file.size <= MAX_FILE_SIZE) {
                                handleInputChange("profilePhoto", file);
                              }
                            }}
                          />
                        </>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Name + Role + Status */}
                  <Col md="7">
                    <h2 className="mb-0">
                      {formData.fullName?.value || "Rakesh Kumar"}
                    </h2>
                    <h3 className="text-muted d-block mb-2">
                      {formData.role?.value || "Administartor"}
                    </h3>
                    <Badge
                      className="px-3 py-2"
                      color={
                        formData.accountStatus?.value === "ACTIVE"
                          ? "success"
                          : "warning"
                      }
                      pill
                    >
                      {formData.accountStatus?.value
                        ? formData.accountStatus.value === "INACTIVE"
                          ? "Suspended"
                          : formData.accountStatus.value
                        : "ACTIVE"}
                    </Badge>
                  </Col>

                  {/* Action Buttons */}
                  <Col md="3" className="text-right">
                    {!isEditing ? (
                      <Button
                        className="btn-deep-blue"
                        color="primary"
                        onClick={handleEdit}
                      >
                        <i class="fa-solid fa-pencil mr-1"></i>
                        Edit Profile
                      </Button>
                    ) : (
                      <>
                        <Button
                          color="secondary"
                          className="mr-2 px-4 py-2"
                          onClick={handleOnCancel}
                        >
                          Cancel
                        </Button>
                        <Button
                          color="primary"
                          className="btn-deep-blue"
                          onClick={() => {
                            setIsEditing(false);
                          }}
                        >
                          Save
                        </Button>
                      </>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Personal Information */}
            <Card className="shadow mb-4">
              <CardHeader className="border-bottom-1 d-flex flex-column m-0">
                <h3>Personal Information</h3>
              </CardHeader>

              <CardBody>
                <Row className="mb-3">
                  <Col md="4">
                    <label className="form-control-label mt-3">
                      Full Name{" "}
                      {isEditing && <span className="text-danger"> *</span>}
                    </label>
                    {isEditing ? (
                      <>
                        <Input
                          type="text"
                          name="fullName"
                          value={formData.fullName.value}
                          className={
                            formData.fullName.error ? "is-invalid" : ""
                          }
                          onChange={(e) =>
                            handleInputChange("fullName", e.target.value)
                          }
                          onBlur={(e) => handleBlur("fullName", e.target.value)}
                          maxLength={100}
                        />
                        {formData.fullName.error && (
                          <small className="invalid-feedback d-block">
                            {formData.fullName.error}
                          </small>
                        )}
                      </>
                    ) : (
                      <p>{formData.fullName.value || "Rakesh Kumar"}</p>
                    )}
                  </Col>
                  <Col md="4">
                    <label className="form-control-label mt-3">
                      Email{" "}
                      {isEditing && <span className="text-danger"> *</span>}
                    </label>
                    {isEditing ? (
                      <>
                        <Input
                          type="email"
                          name="email"
                          value={formData.email.value}
                          className={formData.email.error ? "is-invalid" : ""}
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          onBlur={(e) => handleBlur("email", e.target.value)}
                        />
                        {formData.email.error && (
                          <small className="invalid-feedback d-block">
                            {formData.email.error}
                          </small>
                        )}
                      </>
                    ) : (
                      <p>{formData.email.value || "admin@raychem.com"}</p>
                    )}
                  </Col>
                  <Col md="4">
                    <label className="form-control-label mt-3">
                      Mobile Number
                    </label>

                    {isEditing ? (
                      <>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">+91</span>
                          </div>

                          <Input
                            type="tel"
                            name="mobileNo"
                            maxLength={10}
                            value={formData.mobileNo.value}
                            className={
                              formData.mobileNo.error ? "is-invalid" : ""
                            }
                            onChange={(e) =>
                              handleInputChange("mobileNo", e.target.value)
                            }
                            onBlur={(e) =>
                              handleBlur("mobileNo", e.target.value)
                            }
                          />
                        </div>

                        {formData.mobileNo.error && (
                          <small className="invalid-feedback d-block">
                            {formData.mobileNo.error}
                          </small>
                        )}
                      </>
                    ) : (
                      <p>+91 {formData.mobileNo.value || "9876543210"}</p>
                    )}
                  </Col>

                  <Col md="4">
                    <label className="form-control-label mt-3">
                      Date of Birth
                    </label>
                    {isEditing ? (
                      <>
                        <Input
                          type="date"
                          name="dateOfBirth"
                          value={formData.dateOfBirth.value}
                          className={
                            formData.dateOfBirth.error ? "is-invalid" : ""
                          }
                          onChange={(e) =>
                            handleInputChange("dateOfBirth", e.target.value)
                          }
                          onBlur={(e) =>
                            handleBlur("dateOfBirth", e.target.value)
                          }
                        />
                        {formData.dateOfBirth.error && (
                          <small className="invalid-feedback d-block">
                            {formData.dateOfBirth.error}
                          </small>
                        )}
                      </>
                    ) : (
                      <p>12-10-1990</p>
                    )}
                  </Col>
                  <Col md="4">
                    <label className="form-control-label mt-3">Gender</label>
                    {isEditing ? (
                      <>
                        <Select
                          name="gender"
                          options={genderOptions}
                          styles={SELECT_CUSTOM_STYLES}
                          value={
                            genderOptions.find(
                              (opt) => opt.value === formData.gender.value
                            ) || null
                          }
                          className={formData.gender.error ? "is-invalid" : ""}
                          onBlur={() =>
                            handleBlur("gender", formData.gender.value)
                          }
                          onChange={(selectedOption) =>
                            handleInputChange(
                              "gender",
                              selectedOption ? selectedOption.value : ""
                            )
                          }
                          isClearable
                        />
                        {formData.gender.error && (
                          <small className="invalid-feedback d-block">
                            {formData.gender.error}
                          </small>
                        )}
                      </>
                    ) : (
                      <p>Male</p>
                    )}
                  </Col>
                  <Col md="4">
                    <label className="form-control-label mt-3">
                      Address{" "}
                      {isEditing && <span className="text-danger"> *</span>}
                    </label>
                    {isEditing ? (
                      <>
                        <Input
                          type="textarea"
                          name="address"
                          rows="3"
                          maxLength={250}
                          value={formData.address.value}
                          className={formData.address.error ? "is-invalid" : ""}
                          onChange={(e) =>
                            handleInputChange("address", e.target.value)
                          }
                          onBlur={(e) => handleBlur("address", e.target.value)}
                        />
                        {formData.address.error && (
                          <small className="invalid-feedback d-block">
                            {formData.address.error}
                          </small>
                        )}
                      </>
                    ) : (
                      <p>Mumbai 400001, Maharashtra, India</p>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card className="shadow">
              <CardHeader className="border-bottom-1 d-flex flex-column">
                <h3 className="mb-2">Acount Information</h3>
              </CardHeader>

              <CardBody>
                <Row>
                  <Col md="4">
                    <label className="form-control-label">Role</label>
                    <p>Administrator</p>
                  </Col>
                  <Col md="4">
                    <label className="form-control-label">
                      Account Created On
                    </label>
                    <p>12/12/25</p>
                  </Col>
                  <Col md="4">
                    <label className="form-control-label mt-3">
                      Last Login
                    </label>
                    <p>3 hours ago</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AdminProfile;
